<template>
    <!-- this component has no element -->
</template>

<script>
import Player from "@vimeo/player";

export default{
    props:{
        millisecondsMouseMoveEvent:Number
    },
    data(){
        return {
            vimeoPlayer: null,
            fakeEventCallInterval: null,
            initRetryTimeout: null,
        }
    },
    mounted(){
        this.initializeVimeoPlayer();
    },
    beforeDestroy() {
        if (this.initRetryTimeout) {
            clearTimeout(this.initRetryTimeout);
            this.initRetryTimeout = null;
        }
        this.destroyInterval();
        if (this.vimeoPlayer && typeof this.vimeoPlayer.off === "function") {
            this.vimeoPlayer.off("play");
            this.vimeoPlayer.off("pause");
            this.vimeoPlayer.off("ended");
        }
    },
    methods:{
        initializeVimeoPlayer() {
            // vue-vimeo-player does not guarantee an iframe id; resolve a live Vimeo iframe safely.
            const iframe = document.querySelector("iframe[src*='vimeo.com']");
            if (!iframe) {
                console.log("[VimeoWatcher] player iframe not found yet; retrying");
                this.initRetryTimeout = setTimeout(() => {
                    this.initializeVimeoPlayer();
                }, 300);
                return;
            }

            if (this.vimeoPlayer) {
                return;
            }

            this.vimeoPlayer = new Player(iframe);
            console.log("[VimeoWatcher] player initialized");

            this.vimeoPlayer.on("play", () => {
                console.log("[VimeoWatcher] play");
                this.destroyInterval();
                this.fakeEventCallInterval = setInterval(() => {
                    window.dispatchEvent(new Event("mousemove"));
                }, this.millisecondsMouseMoveEvent);
            });

            this.vimeoPlayer.on("pause", () => {
                console.log("[VimeoWatcher] stop/pause");
                this.destroyInterval();
            });

            this.vimeoPlayer.on("ended", () => {
                console.log("[VimeoWatcher] ended");
                this.destroyInterval();
            });
        },
        destroyInterval(){
            if (this.fakeEventCallInterval) {
                clearInterval(this.fakeEventCallInterval);
                this.fakeEventCallInterval = null;
            }
        }
    }
};

</script>